module.exports = __webpack_public_path__ + "static/img/facebook.603286f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/facebook.svg
// module id = zySR
// module chunks = 1